import { useMemo, useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers';

type CustomDatePickerProps = any; // Rely on consumer prop shapes; avoid custom types per workspace rules

export default function CustomDatePicker(props: CustomDatePickerProps) {
  const [open, setOpen] = useState(false);

  const mergedSlotProps = useMemo(() => {
    const userTextField = props?.slotProps?.textField || {};
    const userInputProps = userTextField.InputProps || {};

    return {
      ...props.slotProps,
      textField: {
        ...userTextField,
        // Make the input feel clickable and open the calendar on click
        onClick: (event: any) => {
          if (typeof userTextField.onClick === 'function') {
            userTextField.onClick(event);
          }
          setOpen(true);
        },
        InputProps: {
          ...userInputProps,
          sx: {
            ...(userInputProps as any).sx,
            cursor: 'pointer',
          },
        },
      },
    };
  }, [props.slotProps]);

  return (
    <DatePicker
      {...props}
      open={open}
      onOpen={() => {
        setOpen(true);
        if (typeof props.onOpen === 'function') props.onOpen();
      }}
      onClose={() => {
        setOpen(false);
        if (typeof props.onClose === 'function') props.onClose();
      }}
      slotProps={mergedSlotProps}
    />
  );
}


